<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>
    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import staffTableMixin from "../mixin/table";

export default {
  name: "StaffMainAccountant",
  mixins: [tableMixin, staffTableMixin],
  data() {
    return {
      formInline: {
        user_group_id: 2,
        iswork: 1,
      },
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/${this.baseUrl}/mainAccountantDetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/${this.baseUrl}/mainAccountantDetail?mode=edit&id=${id}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
        {
          icon: "el-icon-link",
          title: "解绑",
          cb: ({ id }) => {
            this.$confirm("真的要解绑微信吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.unBind(id);
              })
              .catch(() => {
                console.log("取消");
              });
          },
        },
      ],
    };
  },
  methods: {
    addItem() {
      this.$router.push(`/${this.baseUrl}/mainAccountantDetail`);
    },
  },
};
</script>
